import axios from "axios";
import { API_URL } from "../config/api";

const defaultHeaders = {
  "Content-Type": "application/json",
};

export const apiRequest = async (
  endpoint,
  method = "GET",
  data = null,
  params = {},
  headers = {},
) => {
  const isFormData = data instanceof FormData;

  const config = {
    method,
    url: `${API_URL}/${endpoint}`,
    withCredentials: true,
    params: method === "GET" ? params : {},
    data: method !== "GET" ? data : null,
    headers: {
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...headers,
    },
  };

  try {
    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};
